document.addEventListener("DOMContentLoaded", async () => {
    const { default: main } = await import("./scripts/main.js");
    main.init();
});